export default __webpack_public_path__ + "static/media/empty.13b89a05.svg";